import { Eye } from "lucide-react";

import { Button } from "@/design-system/Button";

import { stopViewAs } from "@/shared/session/viewAs";

/**
 * Always on screen while a platform administrator looks at a client's
 * workspace: whose it is, that nothing can be changed, and the way back.
 */
const DETAILED_KEY = "skryptos.viewAs.detailed";

/** Whether the administrator chose the detailed view of a client's cabinet. A
 *  per-browser convenience: unreadable storage means the client's own view. */
export function readDetailed(): boolean {
  try {
    return window.sessionStorage.getItem(DETAILED_KEY) === "1";
  } catch {
    return false;
  }
}

export function writeDetailed(next: boolean): void {
  try {
    window.sessionStorage.setItem(DETAILED_KEY, next ? "1" : "0");
  } catch {
    // Not remembered; the switch still works for this page.
  }
}

export function ViewAsNotice({ name, detailed = false, onDetailed }: {
  readonly name: string;
  readonly detailed?: boolean;
  readonly onDetailed?: (next: boolean) => void;
}): React.JSX.Element {
  return (
    <div
      role="status"
      data-testid="view-as-notice"
      className="mb-4 flex flex-wrap items-center gap-3 rounded-md border border-status-info px-3 py-2 text-body-main text-text-primary"
    >
      <Eye aria-hidden="true" className="size-4 shrink-0 text-status-info" />
      <span className="min-w-0 flex-1">
        Вы смотрите кабинет клиента <strong>{name}</strong> — только просмотр. Кнопки, которыми клиент
        меняет свои настройки (доля реинвеста, докупка, Telegram), здесь скрыты: клиент видит их под своим логином.
      </span>
      {onDetailed !== undefined && (
        <Button type="button" variant="ghost" aria-pressed={detailed} onClick={() => { onDetailed(!detailed); }}>
          {detailed ? "Как видит клиент" : "Подробно (для админа)"}
        </Button>
      )}
      <Button type="button" variant="ghost" onClick={stopViewAs}>
        Вернуться к платформе
      </Button>
    </div>
  );
}
